import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ButtonA from "@src/ruix/components/atoms/buttons/ButtonA";
import PaperA from "@src/ruix/components/atoms/papers/PaperA";
import TitleA from "@src/ruix/components/molecules/Titles/TitleA";
import { ExpertCardItemProps } from "@src/ruix/types";
import GroupA from "../../atoms/groups/GroupA";

const ExpertCardItem = ({
	name,
	job,
	buttonName,
	isDisabled,
	onClickBtn,
	isRecommended,
}: ExpertCardItemProps) => (
	<PaperA px={15} py={15} fullWidth variant="--bg-white" order="row-center-between" gap={10}>
		<GroupA order="column-start-start" gap={4}>
			<TitleA
				title={name}
				label={job}
				labelColor={isDisabled ? undefined : "var(--card-bg)"}
				color={isDisabled ? "disable" : "primary"}
				size="small"
			></TitleA>
		</GroupA>
		<GroupA order="row-center-center" gap={5}>
			{isRecommended ? (
				<ThumbUpOutlinedIcon
					sx={{
						fill: "var(--primary)",
					}}
				/>
			) : (
				<></>
			)}
			<ButtonA
				size="small"
				buttonClass={isDisabled ? "disable" : "primary"}
				onClick={onClickBtn}
			>
				{buttonName}
			</ButtonA>
		</GroupA>
	</PaperA>
);

export default ExpertCardItem;
